const storageFilters = {
  service: true,
  channels: true,
  performed: true,
  attended: true,
  tma: true,
  queue: true,
  tme: true,
  abandoned: true,
  tm_a: true,
  transfered: true,
  tmr: true,
};

//função que pega os valores salvos no localStorage e modifica o status das colunas que tem esses valores
function getStoragedColumnsStatus(defaultValues) {
  const storedValues = localStorage.getItem("filters_manager_columns");
  let storedValuesObj = defaultValues;
  try {
    const parsedValues = JSON.parse(storedValues);
    const hasParsedValues = !!parsedValues;
    if (hasParsedValues) {
      for (const col in parsedValues) {
        const isThisColumnInDefault =
          typeof storedValuesObj === "object" &&
          storedValuesObj.hasOwnProperty(col);
        //verifica se a coluna guardada no storage ainda existe na tabela, se tiver modifica o status dela de acordo com os dados guardados
        if (isThisColumnInDefault) {
          storedValuesObj[col] = parsedValues[col];
        }
      }
    }
  } catch (error) {
    console.log("erro ao tentar fazer o PARSE do conteúdo do storage", error);
  }

  return storedValuesObj;
}

const initialState = localStorage.getItem("filters_manager_columns")
  ? getStoragedColumnsStatus(storageFilters)
  : storageFilters;

const columnsallservices = (state = initialState, action) => {
  switch (action.type) {
    case "CHANGE_COLUMNS_ALL_SERVICE":
      return {
        service: action.service,
        channels: action.channels,
        performed: action.performed,
        attended: action.attended,
        tma: action.tma,
        queue: action.queue,
        tme: action.tme,
        abandoned: action.abandoned,
        tm_a: action.tm_a,
        transfered: action.transfered,
        tmr: action.tmr,
      };
    default:
      return state;
  }
};

export default columnsallservices;
